module.exports = __webpack_public_path__ + "img/最右边的流星.b1d79f66.png";